module.exports = __webpack_public_path__ + "img/ic-code-tip.27cde5fc.png";